export const iconFontAwesomeHumanitarianCar = (
	<i className="fa-solid fa-car"></i>
);
